<template>
  <div class="com-subject-title" :class="{light}">
    <span class="title-bg">
      <slot></slot>
    </span>
  </div>
</template>

<script>
import vueTypes from 'vue-types'

export default {
  name: 'subject-title',
  props: {
    light: vueTypes.bool.def(false)
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.com-subject-title {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  line-height: 1;
  color: #6B4831;

  @include mobile {
    font-size: 22px;
  }
}

.title-bg {
  padding: 0 60px;
  background:
    no-repeat url('https://static001.geekbang.org/resource/image/97/56/973804a4ca4697b851a493ec12573656.png') left center / 35px auto,
    no-repeat url('https://static001.geekbang.org/resource/image/f6/fd/f6953603997faf9d048d54c5fbae1bfd.png') right center / 35px auto;

  @include mobile {
    padding: 0 38px;
    background:
      no-repeat url('https://static001.geekbang.org/resource/image/97/56/973804a4ca4697b851a493ec12573656.png') left center / 28px auto,
      no-repeat url('https://static001.geekbang.org/resource/image/f6/fd/f6953603997faf9d048d54c5fbae1bfd.png') right center / 28px auto;
  }
}

.light {
  &.com-subject-title {
    color: #fff;
  }

  .title-bg {
    background:
    no-repeat url('https://static001.geekbang.org/resource/image/89/c2/89094df6e3e17815acyy334822d33ec2.png') left center / 35px auto,
    no-repeat url('https://static001.geekbang.org/resource/image/29/da/29413c1dc2009285cea27e48df9c5eda.png') right center / 35px auto;
  }
}
</style>
